import React, { forwardRef, MutableRefObject, useMemo } from 'react'
import styled from 'styled-components'

import { TrustIcons } from '@Components/TrustIcons'
import { useGroupVisibilityUpdater } from '@Globals/ScrollPosition'
import { sectionOuter } from '@Globals/Style/mixins'

import { Contact } from './Contact'
import { CopyrightAndPrivacy } from './CopyrightAndPrivacy'
import { CustomerSupport } from './CustomerSupport'
import { Newsletter } from './Newsletter'
import { Payment } from './Payment'
import { Story } from './Story'
import { TrustPilot } from './TrustPilot'

interface StyledFooterProps {
  borderTopColor?: string
  color?: string
}

const StyledFooter = styled.footer<StyledFooterProps>`
  ${sectionOuter};
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  padding-top: 40px;
  padding-bottom: 30px;
  background-color: ${({ color, theme }) => color ?? theme.colors.greyLightest};
  border-top: 1px solid ${({ borderTopColor }) => borderTopColor ?? '#ccc'};

  .footer-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
    max-width: 1200px;
  
  }

  .footer-margin {
    margin-top: -10px;
    margin-bottom: 20px;
  }
`

export const Footer = forwardRef((props, ref) => (
  <StyledFooter ref={ref as MutableRefObject<HTMLDivElement>}>
    <div className="footer-container">
      <Payment />
      <Contact />
      <TrustPilot />
      <CustomerSupport />
      <Newsletter />
      <Story />
    </div>
    <div className="footer-margin">
      <TrustIcons variant="footer" />
    </div>
    <CopyrightAndPrivacy />
  </StyledFooter>
))

export const FooterWithGroupVisibility = () => {
  const ref = useGroupVisibilityUpdater('footer')

  return useMemo(() => <Footer ref={ref} />, [ref])
}
